"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Avatar = _interopRequireDefault(require("@eig-builder/core-ui/Avatar"));

var _styles = require("@material-ui/core/styles");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _hooks = require("../hooks");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var AuthorField = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([""])));

var AuthorAvatarBox = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  /* width: 250px; */\n  display: grid;\n  grid-template-columns: ", ";\n"])), function (props) {
  return props.size === 'small' ? '30px 1fr' : '50px 1fr';
});

var AuthorLinkBox = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  align-self: center;\n  ", "\n"])), function (props) {
  return props.invertColors && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    a{\n      color: white !important;\n      font-weight: bold;\n    }\n  "])));
});

var BlockLink = (0, _styledComponents["default"])(_Link["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  &:hover {\n    text-decoration: none;\n  }\n"])));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    small: {
      width: 24,
      height: 24
    },
    large: {
      width: 41,
      height: 41
    }
  };
}); // used for unsplash author. its tightly coupled with unsplash user object.

var AuthorAvatar = function AuthorAvatar(_ref) {
  var user = _ref.user,
      showAuthorDetails = _ref.showAuthorDetails,
      _ref$linkToUnsplash = _ref.linkToUnsplash,
      linkToUnsplash = _ref$linkToUnsplash === void 0 ? false : _ref$linkToUnsplash,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$viewMore = _ref.viewMore,
      viewMore = _ref$viewMore === void 0 ? false : _ref$viewMore,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === void 0 ? true : _ref$showTitle,
      _ref$invertColors = _ref.invertColors,
      invertColors = _ref$invertColors === void 0 ? false : _ref$invertColors,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      navigate = _ref.navigate,
      nameDisplay = _ref.nameDisplay,
      userNameDisplay = _ref.userNameDisplay;
  var classes = useStyles();

  var _useSearchQuery = (0, _hooks.useSearchQuery)(),
      setSearchQuery = _useSearchQuery.setSearchQuery;

  var nameShow = nameDisplay({
    name: user.name
  });
  var userNameShow = userNameDisplay ? userNameDisplay({
    username: user.userName
  }) : user.userName;
  return /*#__PURE__*/_react["default"].createElement(AuthorField, null, showTitle && /*#__PURE__*/_react["default"].createElement("small", null, multiple ? /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.authorMultiple"
  }) : /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.author"
  })), /*#__PURE__*/_react["default"].createElement(AuthorAvatarBox, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    alt: user.name,
    src: user.profile_image.medium,
    className: classes[size]
  }), /*#__PURE__*/_react["default"].createElement(AuthorLinkBox, {
    invertColors: invertColors
  }, nameShow && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      window.open("http://unsplash.com/".concat(user.username, "?utm_source=endurance-innovation&utm_medium=referral"));
    }
  }, nameShow), userNameShow && /*#__PURE__*/_react["default"].createElement(BlockLink, {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setSearchQuery(user.username, 'author');
      navigate(null, 'free-images', null);
    }
  }, userNameShow))));
};

AuthorAvatar.propTypes = {
  user: _propTypes["default"].object,
  showAuthorDetails: _propTypes["default"].func,
  linkToUnsplash: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  viewMore: _propTypes["default"].bool,
  showTitle: _propTypes["default"].bool,
  invertColors: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'large']),
  navigate: _propTypes["default"].func,
  nameDisplay: _propTypes["default"].func.isRequired,
  userNameDisplay: _propTypes["default"].func
};

var _default = (0, _withContext["default"])(AuthorAvatar);

exports["default"] = _default;